import React from 'react';
import './blog-post.css';

import potluck1 from './pictures/potluck1.png';
import potluck2 from './pictures/potluck2.png';
import potluck3 from './pictures/potluck3.jpg';
import potluck4 from './pictures/potluck4.jpg';


const Potluck = () => {

  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header>
                    <h3 class="site-post-title rounded title-padding">
                        <b>WiC at Work</b>
                    </h3>
                </header>
                <section>
                    <h2>Spring MM2: Potluck Brunch Recap</h2>
                    <p class="site-post-meta">May 24th, 2024</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>
                    Last Friday we had our Potluck Brunch and we had so much fun with all of you! We indulged in a delicious spread of bagels, pancakes, and pastries. 
                    Despite the rainy weather, we moved the party indoors and kept the fun going! A big thanks to everyone who brought 
                    food and joined us for not only this event, but all of our social events this year – 
                    it was an absolute joy to spend time with you all. 
                    <br></br>
                     
                    </p>
                    <img src={potluck1} alt="Group picture"/>
                    <img src={potluck2} alt="Group picture"/>
                    <img src={potluck3} alt="Group picture"/>
                    <img src={potluck4} alt="Brunch"/>
                   
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
export default Potluck;

